import { SaveResponse } from "../../models/api/save";
import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { ClientAcceptancesSTO } from "../../models/pending-approvals";
import { BaseApiService } from "../base/base-api.service";
import { ClientPendingAcceptancesDTO } from "../../models/pending-approvals/client-pending-acceptances-dto";
import { ExpenseReportDTO, ExpenseReportSTO } from "src/models/expense-reports";
import { DTOModel } from "src/models/base/dto-model";
import { ExpenseReportsApprovalFilter } from "src/models/expense-reports/expense-reports-approval-filter";
import { LoadResponse } from "src/models/api/load";
import { STOModel } from "src/models/base/sto-model";

export class MyClientTeamPendingApprovalsApiService extends BaseApiService<ExpenseReportDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/ClientAcceptances",
      loadItemsPath: "",
      saveItemsPath: "",
    });
  }
}

export const clientAcceptExpenseReports = async (
  expenseReportsPropsFilter: ExpenseReportsApprovalFilter
): Promise<LoadResponse<ExpenseReportDTO>> => {
  const apiService = new MyClientTeamPendingApprovalsApiService();
  apiService.useLoadItemsPath("/ClientAcceptExpenseReports");
  const response = apiService.loadItems({ ...expenseReportsPropsFilter });

  return response;
};

export const clientAcceptExpenseReportsByLink = async (
  expenseReportsPropsFilter: ExpenseReportsApprovalFilter
): Promise<LoadResponse<ExpenseReportDTO>> => {
  const apiService = new MyClientTeamPendingApprovalsApiService();
  apiService.useLoadItemsPath("/ClientAcceptExpenseReportsByLink");
  const response = apiService.loadItems({ ...expenseReportsPropsFilter });

  return response;
};
export const clientRejectExpenseReports = async (
  expenseReportsPropsFilter: ExpenseReportsApprovalFilter
): Promise<LoadResponse<ExpenseReportDTO>> => {
  const apiService = new MyClientTeamPendingApprovalsApiService();
  apiService.useLoadItemsPath("/ClientRejectExpenseReports");
  const response = apiService.loadItems({ ...expenseReportsPropsFilter });

  return response;
};

export const clientRejectExpenseReportsByLink = async (
  expenseReportsPropsFilter: ExpenseReportsApprovalFilter
): Promise<LoadResponse<ExpenseReportDTO>> => {
  const apiService = new MyClientTeamPendingApprovalsApiService();
  apiService.useLoadItemsPath("/ClientRejectExpenseReportsByLink");
  const response = apiService.loadItems({ ...expenseReportsPropsFilter });

  return response;
};
